import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {TranslateService} from "@ngx-translate/core";
import {OrderActionType} from "../order-action-display.data";

@Component({
    selector: "wbo-order-action-type-select-options",
    templateUrl: "./order-action-type-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => OrderActionTypeSelectOptionsComponent),
        multi: true
    }]
})
export class OrderActionTypeSelectOptionsComponent extends SelectOptionsComponent {
    OrderActionType = OrderActionType;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
